/**
 * toaster options 
 */
 export interface TosterOption {
    top?: string;
    class?: string,
    closeinmilisec?: number
  }
  
  export interface TosterData {
    message?: string;
    title?: string;
    type?: ToasterType;
    autoCloseTime? : number;
  }
  
  export enum ToasterType {
    Success = 'Success',
    Error = 'Error',
    Warning = 'Warning'
  }